import React from 'react';
import RegistrationFormModal from '../organisms/registration_form_modal';
import { YourClassesProvider } from '../all_classes/context';
import LiveClassesWidget from './organisms/live_classes_widget';
import { UserProvider } from '@magoosh/context/user_context';

export const UpcomingClasses: React.FC = () => {
  return (
    <UserProvider>
      <YourClassesProvider>
        <LiveClassesWidget />
        <RegistrationFormModal />
      </YourClassesProvider>
    </UserProvider>
  );
};

export default UpcomingClasses;
